
import { Vue, Component } from 'vue-property-decorator'
import AboutUsContent from '@/components/layout/AboutUsContent.vue'
import VerticalHeading from '@/components/typography/VerticalHeading.vue'
import SignUpBanner from '@/components/layout/SignUpBanner.vue'
import Packages from '@/components/collections/memberships/Packages.vue'

@Component({
  components: {
    AboutUsContent,
    VerticalHeading,
    SignUpBanner,
    Packages
  }
})

export default class PricingSchedule extends Vue {
}

